"use strict";import{IconsMedium as e}from"./src/IconsMedium.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-icons-medium",e);
//# sourceMappingURL=sp-icons-medium.js.map
